import { useState, createContext } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";
import {
  getLogsAdminService,
  deleteLogAdminService,
  deleteAllLogAdminService,
} from "../../../services/adminServices";

export const logAdminContext = createContext({
  logs: [],
  setLogs: () => {},
  log: {},
  setLog: () => {},
  sort: "",
  setSort: () => {},
  start: "",
  setStart: () => {},
  end: "",
  setEnd: () => {},
  pageCount: null,
  setPageCount: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  itemsCount: null,
  setItemsCount: () => {},
  handleGetLogs: () => {},
  handleDeleteLog: () => {},
  handleDeleteAllLog: () => {},
});

const LogAdminContext = ({ children }) => {
  const dispatch = useDispatch();

  const { user } = useParams();

  const [logs, setLogs] = useState([]);
  const [log, setLog] = useState({});
  const [sort, setSort] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [pageCount, setPageCount] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsCount, setItemsCount] = useState(100);

  // Get Logs
  const handleGetLogs = async (event) => {
    event?.preventDefault();

    const objData = {
      ...(start && { start }),
      ...(end && { end }),
      ...(user && { user }),
      pageNumber,
      sort,
      itemsCount,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getLogsAdminService(objData);
      if (status === 200) {
        setLogs(data.result?.logs);
        setPageCount(data?.result?.allPagesCount);
      }
    } catch ({ response }) {
      
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Delete Log
  const handleDeleteLog = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await deleteLogAdminService(id);
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        handleGetLogs();
      }
    } catch ({ response }) {
      
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
      dispatch(setLoadingFalseAction());
    }
  };

  // Delete All Log
  const handleDeleteAllLog = async () => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await deleteAllLogAdminService();
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        handleGetLogs();
      }
    } catch ({ response }) {
      
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <logAdminContext.Provider
      value={{
        logs,
        setLogs,
        log,
        setLog,
        sort,
        setSort,
        start,
        setStart,
        end,
        setEnd,
        pageCount,
        setPageCount,
        pageNumber,
        setPageNumber,
        itemsCount,
        setItemsCount,
        handleGetLogs,
        handleDeleteLog,
        handleDeleteAllLog,
      }}
    >
      {children}
    </logAdminContext.Provider>
  );
};

export default LogAdminContext;
